// Lightweight environment-aware logger.
// In production builds (`NODE_ENV === 'production'`), debug/info/log/warn are no-ops.
// Errors are always logged so production issues remain observable.
const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
  log: (...args) => { if (isDev) console.log(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
  error: (...args) => { console.error(...args); },
};
